import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FilePdfFilledSvg from "@ant-design/icons-svg/es/asn/FilePdfFilled";
import AntdIcon from "../components/AntdIcon";
var FilePdfFilled = function FilePdfFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilePdfFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FilePdfFilled.displayName = 'FilePdfFilled';
}
export default /*#__PURE__*/React.forwardRef(FilePdfFilled);